module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_ys200@2x.4a1964db.png";